import _styled from "styled-components";
import { runInAction } from "mobx";
import Box from "../../Styled/Box";
import { RawButton } from "../../Styled/Button";
import Spacing from "../../Styled/Spacing";
import { TextSpan } from "../../Styled/Text";
import FeedbackLinkCustomComponent, { FeedbackLink } from "../Custom/FeedbackLinkCustomComponent";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";

// Hard code colour for now
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const warningColor = "#f69900";
const showErrorNotification = (viewState, error) => {
  runInAction(() => {
    error.showDetails = true;
  });
  viewState.terria.raiseErrorToUser(error, undefined, true);
};
const WarningBox = props => {
  var _props$error, _props$error2, _props$error3, _props$viewState;
  // We only show FeedbankLink if the error message doesn't include the <feedbacklink> custom component (so we don't get duplicates)
  const includesFeedbackLink = (_props$error = props.error) === null || _props$error === void 0 ? void 0 : _props$error.highestImportanceError.message.includes("<".concat(FeedbackLinkCustomComponent.componentName));
  return /*#__PURE__*/_jsxs(Box, {
    backgroundColor: warningColor,
    rounded: true,
    padded: true,
    children: [/*#__PURE__*/_jsx(Spacing, {
      right: 1
    }), /*#__PURE__*/_jsx(WarningIcon, {}), /*#__PURE__*/_jsx(Spacing, {
      right: 2
    }), /*#__PURE__*/_jsx(Box, {
      backgroundColor: "#ffffff",
      rounded: true,
      fullWidth: true,
      paddedRatio: 3,
      children: props.error ? /*#__PURE__*/_jsxs("div", {
        children: [parseCustomMarkdownToReact("### ".concat((_props$error2 = props.error) === null || _props$error2 === void 0 || (_props$error2 = _props$error2.highestImportanceError) === null || _props$error2 === void 0 ? void 0 : _props$error2.title)), parseCustomMarkdownToReact((_props$error3 = props.error) === null || _props$error3 === void 0 || (_props$error3 = _props$error3.highestImportanceError) === null || _props$error3 === void 0 ? void 0 : _props$error3.message, {
          viewState: props.viewState,
          terria: (_props$viewState = props.viewState) === null || _props$viewState === void 0 ? void 0 : _props$viewState.terria
        }), props.viewState && !includesFeedbackLink ? /*#__PURE__*/_jsx(FeedbackLink, {
          viewState: props.viewState
        }) : null, props.viewState && Array.isArray(props.error.originalError) && props.error.originalError.length > 0 ? /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(RawButton, {
            activeStyles: true,
            onClick: () => showErrorNotification(props.viewState, props.error),
            children: /*#__PURE__*/_jsx(TextSpan, {
              primary: true,
              isLink: true,
              children: "See details"
            })
          })
        }) : null]
      }) : props.children
    })]
  });
};

// Equilateral triangle
const WarningIcon = () => /*#__PURE__*/_jsx(_StyledP, {
  children: "!"
});
export default WarningBox;
var _StyledP = _styled("p").withConfig({
  displayName: "WarningBox___StyledP",
  componentId: "sc-15hh0vy-0"
})(["width:0px;height:0px;text-indent:-2px;border-left:12px solid transparent;border-right:12px solid transparent;border-bottom:20px solid white;font-weight:bold;line-height:25px;user-select:none;"]);